import { httpBatchLink, loggerLink } from '@trpc/client';
import type { TRPCClient } from '@trpc/client';
import type { CommunityRouter } from '@org/community-server';
import type { QueryClient } from '@tanstack/react-query';
import { createTRPCReact } from '@trpc/react-query';
import superjson from 'superjson';
import { createContext } from 'react';

export const CommunityTrpcContext = createContext(null);
export const communityTrpc = createTRPCReact<CommunityRouter>({ context: CommunityTrpcContext });

export interface CreateCommunityClientOptions {
  queryClient: QueryClient;
  getAccessToken: () => Promise<string>;
  /** Extra headers attached to every request (e.g. admin impersonation). */
  getExtraHeaders?: () => Record<string, string>;
  apiUrl?: string;
  transformer?: typeof superjson;
}

export const createCommunityTrpcClient = ({
  queryClient,
  getAccessToken,
  getExtraHeaders,
  apiUrl = 'http://localhost:3333/community',
  transformer = superjson,
}: CreateCommunityClientOptions): TRPCClient<CommunityRouter> => {
  return communityTrpc.createClient({
    // @ts-ignore
    transformer,
    links: [
      loggerLink({
        enabled: (opts) =>
          process.env.NODE_ENV === 'development' &&
          // @ts-ignore
          (typeof window !== 'undefined' ? true : opts.direction === 'down'),
      }),
      httpBatchLink({
        url: apiUrl,
        // @ts-ignore
        transformer,
        async headers() {
          const extra = getExtraHeaders?.() ?? {};
          try {
            const token = await getAccessToken();
            return {
              ...extra,
              Authorization: `Bearer ${token}`,
            };
          } catch (error) {
            console.error('Failed to get access token for community tRPC request', error);
            return extra;
          }
        },
      }),
    ],
  });
};
